
import React from 'react';
import { TableRow, TableCell } from '@mui/material';

const formatSignedPoint = (value) => {
    const numericValue = Number(value || 0);
    const sign = numericValue > 0 ? '+' : '';
    return `${sign}${numericValue.toLocaleString()}`;
};

function RoundResultRow(props) {
    const user = props.user;
    const index = props.index;
    const isCurrentUser = Boolean(props.isCurrentUser);

    const getTableRowStyle = (index) => {
        //現在1位表記
        if (index == 0) {
            return {backgroundColor: "Gold",}
        //2
        } else if (index == 1) {
            return {backgroundColor: "silver",}
        //3
        } else if (index == 2) {
            return {backgroundColor: "rgb(196 112 34)",}
        //通常順位偶数
        } else if(index % 2 == 0) {
            return {backgroundColor: "rgb(196 112 34)",}
        //通常順位奇数
        } else {
            return {backgroundColor: "rgb(196 112 34)",}
        }
    };
      
      const getTableCellStyle = (index) => {
        if (index == 0) {
            return {
                padding: '6px 8px',
                fontSize: '12px',
                color: '#333',
                textAlign: 'center',
                border: '1px solid rgba(224, 224, 224, 1)',

            }
        } else {
            return {
                padding: '6px 8px',
                fontSize: '12px',
                color: '#333',
                textAlign: 'center',
                border: '1px solid rgba(224, 224, 224, 1)',

            }
        }
    };

    const getRankChangeIcon = (rank, before_rank) => {
        if (before_rank === 0) {
            return '-';
        } else if (rank < before_rank) {
            return '↑';
        } else if (rank > before_rank) {
            return '↓';
        } else {
            return '→';
        }
    }

    return (
        <TableRow style={{
            ...getTableRowStyle(index),
            ...(isCurrentUser ? { outline: '3px solid #2563eb', outlineOffset: '-3px' } : {}),
        }}>
            <TableCell style={{ ...getTableCellStyle(), width: '28px' }}>
                {user.rank === 999 ? '-' : user.rank}
            </TableCell>
            <TableCell style={{ ...getTableCellStyle(), minWidth: '60px', maxWidth: '100px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{user.name}</TableCell>
            <TableCell style={{ ...getTableCellStyle(), width: '40px' }}>{formatSignedPoint(user.balance)}</TableCell>
            <TableCell style={{ ...getTableCellStyle(), width: '40px' }}>{formatSignedPoint(user.total_balance ?? user.balance)}</TableCell>
            <TableCell style={{ ...getTableCellStyle(), width: '36px' }}>{getRankChangeIcon(user.rank, user.before_rank)}</TableCell>
        </TableRow>
    )
}
export default RoundResultRow;
